import { useSuspenseQuery } from '@tanstack/react-query';

import { cacheKeys } from '../config';
import { meetingClient } from '../client/meetingClient';


export type Params = {
  id: number;
};

type Options = {
};

const defaultOptions: Partial<Options> = {
};

export const useMeeting = (params: Params, options: Partial<Options> = defaultOptions) => {
  const { data: { data: meeting } = {}, status, error, isFetching } = useSuspenseQuery({
    queryKey: [cacheKeys.getMeeting, params.id],
    queryFn: () => meetingClient.getMeeting(params),
  });

  return {
    status,
    error,
    isFetching,
    meeting,
  };
};

